<section class="breadcrumb-banner">
    <div class="container">
        <div class="row">
            <div class="col-md-12 col-lg-12">
                <div class="breadcrumb-text">
                    <h1>G.H. Raisoni Memorial Ratlam One Day Open Rapid Chess Tournament 2026 </h1>
                </div>
            </div>
        </div>
    </div>
    <div class="breadcrumb-bottom-img">
        <img src="https://rgicdn.s3.ap-south-1.amazonaws.com/raisoni/rgi/images/identity/white-group-identity.png">
    </div>
</section>
<section class="section-lg">
    <div class="container">
        <div class="sec-title">
            <h2><span>G.H. Raisoni Memorial Ratlam One Day Open Rapid Chess Tournament 2026</span></h2>
        </div>
        <p><strong>Venue: </strong>Rotary Hall Ratlam, Madhya Pradesh</p>
        <p><strong>Organized by: </strong>Ratlam District Chess Association & G.D Anklesaria Rotary Hall Trust</p>
        <p><strong>Tournament Director: </strong>Mr Manish Joshi, President Dewas District Chess Association</p>
        <p><strong>Chief Arbiter: </strong>SNA Vivek Vishwakarma</p>
        <p><strong>Time Control: </strong>15min + 5 sec Increment from move No 1</p>
        <h5 class="primary-purple">Introduction:</h5>
        <p>The G. H. Raisoni Memorial Ratlam One Day Rapid Chess Championship 2026 was successfully
            organized on 4th April 2026. The event aimed to foster teamwork, promote the game of chess
            among students and youth, and provide a professional platform for emerging talents from Ratlam
            and surrounding regions.</p>
        <h5 class="primary-purple">Inaugural Session:</h5>
        <p> The tournament was inaugurated by Chief Guest Harish Verma President Rotary Club Ratlam
            Deepak Pant Secretary Rotary Club Ratlam in the presence of dignitaries, guests, and chess
            enthusiasts. The chief guest appreciated the organizers efforts in promoting sports culture and
            highlighted the importance of discipline and strategic thinking in chess.</p>
        <h5 class="primary-purple"> Conduct of the Event:</h5>
        <p>The Tournament Was Conducted Under the Guidance of Qualified FIDE Arbiters and Officials
            from the Ratlam District Chess Association. The matches were managed smoothly, maintaining
            a professional and fair atmosphere throughout the event. The venue arrangements, digital pairing
            display, and live score updates ensured a pleasant experience for both players and visitors.</p>
        <h5 class="primary-purple"> Prize Distribution</h5>
        <p> Ceremony The Chief Guest Rohit Malpani, Amarpal vadwa, felicitated the winners and
            participants. The ceremony concluded with motivating words that inspired the young players to
            continue their chess journey with passion and dedication.</p>
        <h5 class="primary-purple"> Acknowledgments:</h5>
        <p>The success of this event was made possible through the generous support and collaboration of
            our sponsors and partners.</p>
        <h5 class="primary-purple">We express our sincere gratitude to:</h5>
        <ul class="list-style list-style1 mb-3">
            <li><strong> Kalpana Prakash Welfare Foundation & G. H. Raisoni Sports & Cultural
                    Foundation –</strong> for their continuous encouragement and sponsorship support. </li>
            <li><strong> Ratlam District Chess Association –</strong> for granting official recognition and technical
                guidance. </li>
            <li><strong> All Arbiters, Volunteers, and Officials –</strong> for their tireless work ensuring smooth
                conduct
                of the championship.</li>
            <li><strong> Participants, Parents, and Coaches –</strong> for their enthusiastic participation and
                cooperation.</li>
        </ul>
        <h5 class="primary-purple">Conclusion:</h5>
        <p>The G. H. Raisoni Memorial Rtalam One Day Open Chess Championship 2026 concluded
            successfully, achieving its objectives of promoting chess and nurturing young talent. The
            tournament created a platform that combined competition, learning, and camaraderie.
            We look forward to organizing more such events with continued support from our esteemed
            sponsors and partners.</p>
        <div class="sec-title mt-5 mb-1 text-center">
            <h2><span>Photo Gallery</span></h2>
        </div>
        <div class="lightBox--gallery">
            <ul class="list-unstyled lightgallery justify-content-center row row-cols-2 row-cols-md-3">
                <li class="col"
                    data-responsive="https://ghrscfcdn.s3.ap-south-1.amazonaws.com/ghrscf/images/events/ratlam-1.webp"
                    data-src="https://ghrscfcdn.s3.ap-south-1.amazonaws.com/ghrscf/images/events/ratlam-1.webp">
                    <a href="Javascript:void(0);">
                        <img src="https://ghrscfcdn.s3.ap-south-1.amazonaws.com/ghrscf/images/events/ratlam-1.webp"
                            alt="GHRSCF" title="GHRSCF" class="img-fluid" />
                        <div class="light-gallery-poster">
                            <img src="https://ghrscfcdn.s3.ap-south-1.amazonaws.com/ghrscf/images/zoom-icon.png" />
                        </div>
                    </a>
                </li>
                <li class="col"
                    data-responsive="https://ghrscfcdn.s3.ap-south-1.amazonaws.com/ghrscf/images/events/ratlam-2.webp"
                    data-src="https://ghrscfcdn.s3.ap-south-1.amazonaws.com/ghrscf/images/events/ratlam-2.webp">
                    <a href="Javascript:void(0);">
                        <img src="https://ghrscfcdn.s3.ap-south-1.amazonaws.com/ghrscf/images/events/ratlam-2.webp"
                            alt="GHRSCF" title="GHRSCF" class="img-fluid" />
                        <div class="light-gallery-poster">
                            <img src="https://ghrscfcdn.s3.ap-south-1.amazonaws.com/ghrscf/images/zoom-icon.png" />
                        </div>
                    </a>
                </li>
                <li class="col"
                    data-responsive="https://ghrscfcdn.s3.ap-south-1.amazonaws.com/ghrscf/images/events/ratlam-3.webp"
                    data-src="https://ghrscfcdn.s3.ap-south-1.amazonaws.com/ghrscf/images/events/ratlam-3.webp">
                    <a href="Javascript:void(0);">
                        <img src="https://ghrscfcdn.s3.ap-south-1.amazonaws.com/ghrscf/images/events/ratlam-3.webp"
                            alt="GHRSCF" title="GHRSCF" class="img-fluid" />
                        <div class="light-gallery-poster">
                            <img src="https://ghrscfcdn.s3.ap-south-1.amazonaws.com/ghrscf/images/zoom-icon.png" />
                        </div>
                    </a>
                </li>
            </ul>
        </div>
        <div class="row row-cols-1 row-cols-md-2">
            <div class="col-lg-6">
                <div class="gall-ery">
                    <div class="row">
                        <div class="col-md-8">
                            <div class="widget_title inner-title gall-sys shadow-text-sm">
                                <h4 class="fw-bold">Prize List</h4>
                            </div>
                        </div>

                    </div>
                    <iframe
                        src="https://ghrscfcdn.s3.ap-south-1.amazonaws.com/ghrscf/images/events/tournament-report-ratlam-kapal.pdf"
                        width="100% " height="500px" frameborder="0"></iframe>
                </div>
            </div>
            <div class="col-lg-6">
                <div class="gall-ery">
                    <div class="row">
                        <div class="col-md-8">
                            <div class="widget_title inner-title gall-sys shadow-text-sm">
                                <h4 class="fw-bold">Tournament Report</h4>
                            </div>
                        </div>

                    </div>
                    <iframe
                        src="https://ghrscfcdn.s3.ap-south-1.amazonaws.com/ghrscf/images/events/tournament-report-ratlam.pdf"
                        width="100% " height="500px" frameborder="0"></iframe>
                </div>
            </div>
        </div>
    </div>
</section>
